export function ensureGlobalGa4(target, measurementId) {
  try {
    if (!target || typeof measurementId !== "string" || !/^G-[A-Z0-9]+$/.test(measurementId)) return false;
    const consentCookie = target.document.cookie
      .split(";")
      .map(value => value.trim())
      .find(value => value.startsWith("cookie_consent_level="));
    if (
      !consentCookie ||
      JSON.parse(decodeURIComponent(consentCookie.slice("cookie_consent_level=".length))).tracking !== true
    )
      return false;

    target.dataLayer = target.dataLayer || [];
    if (typeof target.gtag !== "function") {
      target.gtag = function () {
        target.dataLayer.push(arguments);
      };
      target.gtag("js", new Date());
    }
    if (!target.document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      const script = target.document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      target.document.head.appendChild(script);
    }
    const configured = target.__onlandGlobalGa4Ids || (target.__onlandGlobalGa4Ids = {});
    if (!configured[measurementId]) {
      target.gtag("config", measurementId, { send_page_view: false, groups: "onland_global" });
      configured[measurementId] = true;
    }
    return true;
  } catch (error) {
    return false;
  }
}
